import { REPORT_REQUEST, REPORT_ERROR, REPORT_SUCCESS, REPORT_PARAMETERS,REPORT_RESTAPI } from "../actions/report";
import apiCall from "../../utils/api";
import Vue from "vue";
import { AUTH_LOGOUT } from "../actions/auth";
import axios from "axios";

const state = {status: "", reportViewParameters: {reportType: "", sales: 0, naics: "", range: "", state: "", zip: "" },
axiosData: {}, RESTAPI: ""
 };

const getters = {
  getreportViewParameters: state => state.reportViewParameters,
  getAxiosData: state => state.axiosData,
};

const actions = {
  [REPORT_REQUEST]: ({ commit, dispatch,rootGetters },parameters) => {
    console.log("**REPORT_REQUEST***");
    console.log(parameters);
    console.log(state.reportViewParameters);

    // get the credentials from the auth module
    console.log(rootGetters);
    console.log(rootGetters.authCredentials);
    console.log(rootGetters.authToken);

    var p = state.reportViewParameters
    console.log("**REPORT_REQUEST-- var p***");
    console.log(p);
    commit(REPORT_REQUEST);
    const options = {
      headers: {'X-Token': rootGetters.authToken}
    };
    var URI = state.RESTAPI + "/api/Reports/Norm";

    axios
      .post(URI, { reportType: p.reportType, salestype: p.salesType,sales: p.sales,   naics: p.naics, range: p.range, state: p.state, zip: p.zip },options)
      .then(r => {
        console.log("**Axios Response-then***");
    console.log(r)

      commit(REPORT_SUCCESS,r.data);

      })
      .catch(err => {
        console.log("**Axios Response-catch***");
        commit(REPORT_ERROR);
        reject(err);
      });



  }
};

const mutations = {
  [REPORT_PARAMETERS]: (state,parameters) => {
    console.log("**REPORT_PARAMETERS-mutation***");
    console.log(parameters);
    state.status = "set-parameters";

    // extract out the sales Range
    var therange
    if( parameters.salestype == "Exact") {
      therange = ""
    } else {
      therange = parameters.salesrange.substring(6,8)
    }
    state.reportViewParameters = {reportType: parameters.report, salesType: parameters.salestype,  sales: parameters.salesexact,
       naics: parameters.naics, range: therange, state: "",
       zip: "" }

       console.log(state.reportViewParameters);
    console.log("**REPORT_PARAMETERS-mutation--END***");


  },
  [REPORT_REQUEST]: (state) => {
    console.log("**REPORT_REQUEST-mutation***");
    state.status = "loading";
    // state.axiosData = data;
  },
  [REPORT_SUCCESS]: (state, data) => {
    console.log("**REPORT_SUCCESS-mutation***");
    state.status = "success";
    state.axiosData = data;
  //  Vue.set(state, "profile", resp);
  },
  [REPORT_RESTAPI]: (state, api) => {
    console.log("**REPORT_RESTAPI-mutation***");
    state.RESTAPI = api;
  //  Vue.set(state, "profile", resp);
  },
    [REPORT_ERROR]: state => {
    state.status = "error";
    state.axiosData = {};
  },
  [AUTH_LOGOUT]: state => {
    state.profile = {};
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/report.js